import { combineReducers } from 'redux';
import audience from './audience';

export default combineReducers({
    audience
})